import { Component, EventEmitter, forwardRef, Host, Input, OnInit, Optional, Output, SkipSelf } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { RedirectSelectInsurance } from 'src/app/models/type/redirect-select-insurance.enum';
import { SelfPackageFactoryService } from 'src/app/services/self-package-factory.service';
import { UtilityService } from 'src/app/services/utility.service';
import { FormComponentControl } from '../form-component-control';

@Component({
  selector: 'app-choose-insurance-plan',
  templateUrl: './choose-insurance-plan.component.html',
  styleUrls: ['./choose-insurance-plan.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ChooseInsurancePlanComponent),
      multi: true
    }
  ]
})
export class ChooseInsurancePlanComponent extends FormComponentControl implements OnInit {
  @Input() urlTo: string;
  @Input() urlRedirectTo: RedirectSelectInsurance;
  @Input() tab: any;
  @Input() title: any;
  @Input() isDisabled: boolean;
  @Input() cardStyleClass: any;
  @Input() cardBodyStyleClass: any;
  @Input() textStyleClass: any;
  @Output() clickPlan: EventEmitter<any> = new EventEmitter();

  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer,
    private utilityService: UtilityService,
    private selfPackageFactoryService: SelfPackageFactoryService
  ) { super(cc); }

  ngOnInit() {
    this.checkInitialControl();
  }

  btnClick() {
    if (!this.isDisabled) {
      this.clickPlan.emit(this.tab);
      if (this.tab) {
        this.selfPackageFactoryService.setTab(this.tab);
      }
      if (this.urlTo) {
        const redirectTo = this.urlRedirectTo ? { redirectTo: this.urlRedirectTo, tab: this.tab } : {};
        this.utilityService.routerNavigate(this.urlTo, redirectTo);
      }
    }
  }

}
